import i18next from 'i18next';

i18next.addResources('es', 'error', {
  notFound: 'No pudimos encontrar esta página o link.',
  noExist:
    'Puede que la página que busca ya no exista o haya sido movida. Intente de nuevo o vuelva al inicio. Disculpe las molestias.',
  backToHome: 'Volver al Inicio'
});
